import { render, staticRenderFns } from "./ResumenCifras_new.vue?vue&type=template&id=cceff324&"
import script from "./ResumenCifras_new.vue?vue&type=script&lang=js&"
export * from "./ResumenCifras_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports